/* eslint-disable react/jsx-props-no-spreading */
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { getEnvironment } from '~/store/selectors';
import { actions as modalsActions } from '~/modals';

const Composer = lazy(() =>
  import(
    /* webpackChunkName: "composer" */ '~/composer/interfaces/buffer-publish'
  )
);

const ConnectedComposer = (props) => (
  <Suspense fallback={<div>Loading...</div>}>
    <Composer {...props} />
  </Suspense>
);

const canShowPreviewModeOnPage = (pathname) => {
  const isCalendarPage = pathname.includes('calendar');
  const isIdeasPage = pathname.includes('content');
  return isCalendarPage || isIdeasPage;
};

export default connect(
  (state, ownProps) => {
    if (state.user && state.profileSidebar) {
      const {
        type,
        onCancelDismissModal,
        showDismissComposerModal,
        onConfirmDismissComposer,
      } = ownProps;

      let { selectedProfileId } = state.profileSidebar; // Provided when in the context of a single profile (e.g. queue)
      let selectedProfileIds; // Provided when in the context of multiple profiles (e.g. calendar)

      const postId = state[type]?.editingPostId;
      let options = {};

      switch (type) {
        case 'drafts':
          options = {
            editMode: state.drafts.editMode,
            post: state.drafts?.byProfileId?.[selectedProfileId]?.drafts?.[
              postId
            ],
            draftMode: true,
            shouldResetComposerData: true,
          };
          break;
        case 'campaign': {
          const posts = state.campaign.campaignPosts;
          const { draftMode, editMode } = state.campaign;
          let post = posts.find((p) => p.id === postId);

          ({ selectedProfileId } = state.campaign);

          // Overriding Post times if sharing again:
          // We consider sharing again if not on edit mode and a postId has been shared
          if (!editMode && postId) {
            post = {
              ...post,
              // override some properties
              id: undefined,
              scheduled_at: undefined,
              scheduledAt: undefined,
              due_at: undefined,
            };
          }

          options = {
            editMode,
            post: post || {},
            draftMode,
            initialCampaignId: state.campaign.campaign?.id || null,
          };
          break;
        }
        case 'sent':
          selectedProfileIds = state.sent.selectedProfileIds;

          options = {
            editMode: state.sent.editMode,
            sentPost: true,
            post: {
              ...state.sent.byProfileId[selectedProfileId].posts[postId],
              scheduled_at: null,
              pinned: null,
              text: state.sent.post?.text || null,
            },
          };
          break;
        case 'pastReminders':
          options = {
            editMode: state.pastReminders.editMode,
            sentPost: true,
            post: {
              ...state.pastReminders.byProfileId[selectedProfileId].posts[
                postId
              ],
              scheduled_at: null,
              pinned: null,
            },
          };
          break;
        case 'pendingTiktok':
        case 'queue':
        case 'composerPopover': {
          selectedProfileId = state.composerPopover.selectedProfileId;
          selectedProfileIds = state.composerPopover.selectedProfileIds;
          const {
            post,
            editMode,
            emptySlotMode,
            hasDefaultTime,
            emptySlotData,
            shouldResetComposerData,
          } = state.composerPopover;
          const { profiles } = state.profileSidebar;
          const canPreviewOnPage = canShowPreviewModeOnPage(
            state.router.location.pathname
          );

          options = {
            editMode,
            emptySlotMode,
            hasDefaultTime,
            shouldResetComposerData,
            post: emptySlotMode ? emptySlotData : post,
            previewMode: canPreviewOnPage && (!profiles || !profiles.length),
          };
          break;
        }
        default:
          return;
      }

      const profilesToBeSelected =
        selectedProfileIds && !!selectedProfileIds.length
          ? selectedProfileIds
          : [selectedProfileId];

      return {
        userData: state.user,
        profiles: state.profileSidebar.profiles.map((profile) => ({
          ...profile,
          shouldBeAutoSelected: profilesToBeSelected.includes(profile.id),
        })),
        organizations: state.organizations,
        enabledApplicationModes: state.temporaryBanner.enabledApplicationModes,
        environment: getEnvironment(state),
        draftMode: false,
        profilesToBeSelected,
        tabId: state.profileNav.selectedTabId,
        campaigns: state.campaignsList.campaigns ?? [],
        showDismissComposerModal,
        onCancelDismissModal,
        onConfirmDismissComposer,
        translations: state.i18n.translations,
        ...options,
      };
    }
    return {};
  },
  (dispatch, ownProps) => ({
    onEvent: (type, data) => {
      if (type === 'backdrop-clicked') {
        ownProps.onComposerOverlayClick();
      }
      dispatch({ type: 'COMPOSER_EVENT', eventType: type, data });
    },
    onInteraction: ({ message }) => {
      switch (message.action) {
        case 'COMMENT_ENABLED':
          dispatch(modalsActions.showInstagramFirstCommentModal(message));
          break;
        default:
          break;
      }
    },
  })
)(ConnectedComposer);
